module.exports = __webpack_public_path__ + "img/delete.621ef5b9.svg";